import { Button } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AlertsContext } from "providers/alerts";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { useContext, useState } from "react";
import { apiRequest } from "utils/api";
import { getCustomButtonVariant } from "utils/uiconfighelper";

const SaveScenario = ({ scenario }: { scenario: any }) => {
  const { showSuccess, showError } = useContext(AlertsContext);
  const { user } = useTenant();
  const [saving, setSaving] = useState(false);

  const saveScenario = async () => {
    setSaving(true);

    try {
      await apiRequest("/supabase/scenarios/update", {
        id: scenario.id,
        params: scenario,
      });
      showSuccess({
        title: "Scenario Saved",
        description: "The scenario updates have been successfully saved.",
      });
    } catch (err) {
      showError();
    } finally {
      setSaving(false);
    }
  };

  return (
    <Button
      size="sm"
      variant={getCustomButtonVariant(user)}
      ml="12px"
      leftIcon={<FontAwesomeIcon icon={["far", "save"]} />}
      onClick={saveScenario}
      isDisabled={saving}
    >
      {saving ? "Saving..." : "Save Scenario"}
    </Button>
  );
};

export default SaveScenario;
